import React, { useState } from 'react';
import Script from 'next/script';

import { IVideoBlockFullwidthFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';
import { trackWithFingerprint } from '../../utils/trackWithFingerprint';
import { getPartnerTrackingProperties } from '../../utils/getPartnerTrackingProperties';

import { Lightbox } from '../VideoBlock/Lightbox';
import { VideoContainerContent } from './VideoContainerContent';
import { GlImage } from '../Image';

export function VimeoVideo({
  title,
  vimeoId,
  backgroundImage,
  mobileButtonStyle,
  desktopButtonStyle
}: IVideoBlockFullwidthFields) {
  const [showingVideo, setShowingVideo] = useState(false);

  const toggleVideo = (displayVideo: boolean) => {
    setShowingVideo(displayVideo);
    if (displayVideo) {
      trackWithFingerprint('Video Opened', {
        page_url: window.location.href,
        ...getPartnerTrackingProperties()
      });
    } else {
      trackWithFingerprint('Video Closed', {
        page_url: window.location.href,
        ...getPartnerTrackingProperties()
      });
      document.getElementById('gl-video-play-button')?.focus();
    }
  };

  return (
    <div className="grid w-full relative h-[18.75rem] desktop:h-[35.9375rem] rounded-4xl desktop:rounded-[6.5rem] overflow-hidden">
      <Script src="https://player.vimeo.com/api/player.js" />
      <GlImage
        {...getImageData(backgroundImage)}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="relative place-items-center grid">
        <VideoContainerContent
          mobileButtonStyle={mobileButtonStyle}
          desktopButtonStyle={desktopButtonStyle}
          toggleVideo={toggleVideo}
        />

        {vimeoId && title && (
          <Lightbox
            title={title}
            showingVideo={showingVideo}
            setShowingVideo={toggleVideo}
            vimeoId={vimeoId}
          />
        )}
      </div>
    </div>
  );
}
